import { render, staticRenderFns } from "./basic-package.vue?vue&type=template&id=03a44b8d&scoped=true&"
import script from "./basic-package.vue?vue&type=script&lang=js&"
export * from "./basic-package.vue?vue&type=script&lang=js&"
import style0 from "./basic-package.vue?vue&type=style&index=0&id=03a44b8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a44b8d",
  null
  
)

export default component.exports